import {format, isValid, isWeekend, parseISO, subDays} from 'date-fns';

export const ADJUSTED_DEADLINE_LABEL = 'Deadline';
export const ADJUSTED_DEADLINE_TOOLTIP = 'Ready to ship deadline minus one business day';
export const MISSING_ADJUSTED_DEADLINE_TEXT = 'Not Set';

export function calculateAdjustedDeadline(readyToShipDeadline?: string | null): Date | null {
  if (!readyToShipDeadline) {
    return null;
  }

  const parsedReadyToShipDeadline = parseISO(readyToShipDeadline);
  if (!isValid(parsedReadyToShipDeadline)) {
    return null;
  }

  let adjustedDeadline = subDays(parsedReadyToShipDeadline, 1);
  while (isWeekend(adjustedDeadline)) {
    adjustedDeadline = subDays(adjustedDeadline, 1);
  }

  return adjustedDeadline;
}

export function formatAdjustedDeadline(readyToShipDeadline?: string | null): string {
  const adjustedDeadline = calculateAdjustedDeadline(readyToShipDeadline);

  return adjustedDeadline
    ? format(adjustedDeadline, 'MMMM d, yyyy')
    : MISSING_ADJUSTED_DEADLINE_TEXT;
}
